export default [
    {
        path: '/reorder-point/list/:filter?',
        name: 'reorder_point_list',
        component: () => import('@src/reorder-point/reorder-point-list.vue'),
        meta: {
            title: 'Meldebestände',
            role: 'ROLE_SHOW_REORDER_POINT',
        },
    },
    {
        path: '/reorder-point/below-list/:filter?',
        name: 'reorder_point_below_list',
        component: () => import('@src/reorder-point/below-reorder-point-list.vue'),
        meta: {
            title: 'Unterschrittene Meldebestände',
            role: 'ROLE_SHOW_REORDER_POINT',
        },
    },
    {
        path: '/reorder-point/edit/:id',
        name: 'reorder_point_edit',
        component: () => import('@src/reorder-point/reorder-point-edit.vue'),
        props(route: any) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        meta: {
            title: 'Meldebestand bearbeiten',
            role: 'ROLE_EDIT_REORDER_POINT',
        },
    },
];
